var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pre-loader"},[_c('div',{staticClass:"spin-box",on:{"click":function($event){$event.preventDefault();return (function () {})($event)}}},[_c('div',{staticClass:"loader",attrs:{"title":"0"}},[_c('loaderSvg')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }